import { ServiceTemplateBundlePricingTypeEnum } from "./model";
export const pricingType = bundle => bundle.pricingType;
export const services = bundle => bundle.services;
export const pricingTypeFixed = bundle => bundle.pricingType.type === ServiceTemplateBundlePricingTypeEnum.Fixed ? bundle.pricingType : null;
export const pricingTypeVariable = bundle => bundle.pricingType.type === ServiceTemplateBundlePricingTypeEnum.Variable ? bundle.pricingType : null;